"use client";

import { c as _c } from "react/compiler-runtime";
import { Toaster } from "@anima/ui/components/sonner";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "@/utils/trpc";
import { ThemeProvider } from "@/lib/theme-provider";
import { TooltipProvider } from "@anima/ui/components/tooltip";
import NextTopLoader from "nextjs-toploader";
import { CollaborationProvider } from "@/components/editor/collaboration-provider";
import { AnimaHotkeysProvider } from "@/components/hotkeys-provider";
export default function Providers(t0) {
  const $ = _c(9);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <NextTopLoader />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <TooltipProvider><AnimaHotkeysProvider>{children}</AnimaHotkeysProvider></TooltipProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ReactQueryDevtools />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <QueryClientProvider client={queryClient}>{t2}{t3}</QueryClientProvider>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Toaster richColors={true} />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4) {
    t6 = <CollaborationProvider><ThemeProvider attribute="class" defaultTheme="system" enableSystem={true} disableTransitionOnChange={true}>{t1}{t4}{t5}</ThemeProvider></CollaborationProvider>;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}